import { initializeApp, getApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const somerenlabs0Config = {
  apiKey: "AIzaSyC1cVmT8RyfN36NHtlvtI3Q0BdWN8IbhMs",
  authDomain: "somerenlabs0.firebaseapp.com",
  projectId: "somerenlabs0",
  storageBucket: "somerenlabs0.firebasestorage.app",
  messagingSenderId: "753771921660",
  appId: "1:753771921660:web:493a5fe5db132921661779"
};

const ACCESS_APP_NAME = "somerenlabs0-access";
const accessApp = getApps().some((app) => app.name === ACCESS_APP_NAME)
  ? getApp(ACCESS_APP_NAME)
  : initializeApp(somerenlabs0Config, ACCESS_APP_NAME);

export const somerenAccessDb = getFirestore(accessApp);
